import React from 'react';
import IntlMessages from 'Util/IntlMessages';

const BasicButton = ({ label, onClick, ...props }) => {
  return (
    <button className="signin-basic-button" onClick={onClick} {...props}>
      <IntlMessages id={label} />
    </button>
  );
};

export default BasicButton;
